import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";

import { useEffect } from "react";
import { useAccountId } from "../../../auth/useAccountId";
import Icon from "../../../components/Icons";
import { LoadingOverlay } from "../../../components/Loading";
import Page, { PageButton } from "../../../components/Page";
import { H1 } from "../../../components/Typography";
import usePayoutDestinations from "../../../util/usePayoutDestinations";
import { useReports } from "../hooks/useReports";
import ConfigurationsTable from "./ConfigurationsTable";
import CreateConfigurationModal from "./CreateConfigurationModal";
import DeleteConfigurationModal from "./DeleteConfigurationModal";
import NoData from "./NoData";

export const ReportConfigurationsList = () => {
    const accountId = useAccountId();
    const { t } = useTranslation();
    const {
        configurations,
        isLoading,
        configurationToDelete,
        showNewConfigurationModal,
        createError,
        openDeleteModal,
        openNewModal,
        closeDeleteModal,
        closeNewModal,
        postNewConfiguration,
        removeConfiguration,
        resetStore,
    } = useReports();

    const hasConfigurations = Boolean(
        accountId && (configurations || []).length > 0,
    );

    const { destinationOptions, destinationIdLabelMap } =
        usePayoutDestinations();

    // biome-ignore lint/correctness/useExhaustiveDependencies: Only run on unmount
    useEffect(() => {
        return () => {
            resetStore();
        };
    }, []);

    return (
        <>
            <Page
                title={
                    <>
                        <Title>{t("settings.reports.title")}</Title>
                        <PageButton onClick={openNewModal}>
                            <Icon icon="plus" fill="currentColor" />
                            {t("settings.reports.create_new_report")}
                        </PageButton>
                    </>
                }
            >
                {hasConfigurations && (
                    <ConfigurationsTable
                        accountId={accountId}
                        configurations={configurations || []}
                        openDeleteModal={openDeleteModal}
                        destinationIdLabelMap={destinationIdLabelMap}
                    />
                )}
                {isLoading && <LoadingOverlay />}
                {!isLoading && !hasConfigurations && (
                    <NoData openNewModal={openNewModal} />
                )}
            </Page>
            {accountId && configurationToDelete && (
                <DeleteConfigurationModal
                    accountId={accountId}
                    configuration={configurationToDelete}
                    removeConfiguration={removeConfiguration}
                    dismissModal={closeDeleteModal}
                />
            )}
            {showNewConfigurationModal && (
                <CreateConfigurationModal
                    destinations={destinationOptions}
                    dismissModal={closeNewModal}
                    accountId={accountId}
                    createConfiguration={postNewConfiguration}
                    createError={createError}
                />
            )}
        </>
    );
};
const Title = styled(H1 as any)`
    display: inline-block;
        /* Heading/H6/Medium/Desktop */
        font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px; /* 140% */
    letter-spacing: -0.4px;
`;
